(() => {
  const monthlyCampaignRootSelector = '[data-monthly-campaign-archive="true"]';
  const monthlyCampaignTimerSelector = '[data-monthly-campaign-archive-timer="true"]';

  const closeMonthlyCampaign = (root) => {
    if (!root || root.dataset.monthlyCampaignExpired === 'true') return;

    root.dataset.monthlyCampaignExpired = 'true';

    root.querySelectorAll('[data-monthly-campaign-tracker]').forEach((tracker) => {
      tracker.hidden = true;
      tracker.setAttribute('aria-hidden', 'true');
    });

    root.querySelectorAll('[data-monthly-campaign-purchase-active]').forEach((purchaseState) => {
      purchaseState.hidden = true;
      purchaseState.setAttribute('aria-hidden', 'true');

      purchaseState.querySelectorAll('button, input, select, textarea').forEach((control) => {
        control.disabled = true;
      });
    });

    root.querySelectorAll('[data-monthly-campaign-sales-closed]').forEach((closedState) => {
      closedState.hidden = false;
      closedState.removeAttribute('aria-hidden');
    });
  };

  const handleCountdownCompletion = (event) => {
    const countdownBlock = event.target.closest('[data-countdown-block]');
    const campaignTimer = countdownBlock?.querySelector(monthlyCampaignTimerSelector);
    const campaignRoot = countdownBlock?.closest(monthlyCampaignRootSelector);

    if (campaignTimer && campaignRoot) {
      closeMonthlyCampaign(campaignRoot);
    }
  };

  document.addEventListener('theme:countdown:expire', handleCountdownCompletion);
  document.addEventListener('theme:countdown:hide', handleCountdownCompletion);
})();
